export default __webpack_public_path__ + "static/media/group-option-eye-unselected.66f8c76b.svg";